/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Copy_ErrorInputs */

const en_salary_negotiate_copy_error = /** @type {(inputs: Salary_Negotiate_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy to clipboard.`)
};

const de_salary_negotiate_copy_error = /** @type {(inputs: Salary_Negotiate_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konnte nicht in die Zwischenablage kopiert werden.`)
};

const fr_salary_negotiate_copy_error = /** @type {(inputs: Salary_Negotiate_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de copier dans le presse-papiers.`)
};

const es_salary_negotiate_copy_error = /** @type {(inputs: Salary_Negotiate_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo copiar al portapapeles.`)
};

const it_salary_negotiate_copy_error = /** @type {(inputs: Salary_Negotiate_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia negli appunti non riuscita.`)
};

const nl_salary_negotiate_copy_error = /** @type {(inputs: Salary_Negotiate_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiëren naar klembord mislukt.`)
};

const pl_salary_negotiate_copy_error = /** @type {(inputs: Salary_Negotiate_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiowanie do schowka nie powiodło się.`)
};

const fi_salary_negotiate_copy_error = /** @type {(inputs: Salary_Negotiate_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leikepöydälle kopioiminen epäonnistui.`)
};

const da_salary_negotiate_copy_error = /** @type {(inputs: Salary_Negotiate_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke kopiere til udklipsholder.`)
};

const sv_salary_negotiate_copy_error = /** @type {(inputs: Salary_Negotiate_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte kopiera till urklipp.`)
};

/**
* | output |
* | --- |
* | "Failed to copy to clipboard." |
*
* @param {Salary_Negotiate_Copy_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_copy_error = /** @type {((inputs?: Salary_Negotiate_Copy_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Copy_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_copy_error(inputs)
	if (locale === "fr") return fr_salary_negotiate_copy_error(inputs)
	if (locale === "es") return es_salary_negotiate_copy_error(inputs)
	if (locale === "it") return it_salary_negotiate_copy_error(inputs)
	if (locale === "nl") return nl_salary_negotiate_copy_error(inputs)
	if (locale === "pl") return pl_salary_negotiate_copy_error(inputs)
	if (locale === "fi") return fi_salary_negotiate_copy_error(inputs)
	if (locale === "da") return da_salary_negotiate_copy_error(inputs)
	if (locale === "sv") return sv_salary_negotiate_copy_error(inputs)
	return en_salary_negotiate_copy_error(inputs)
});